// @flow weak

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import bemify, { toModifiers } from 'bemify-js';

import KindPropType from 'app/common/KindPropType';
import Link from 'app/common/components/Link';
import TruncatedText from 'app/common/components/TruncatedText';
import { isSubUrlOf } from 'app/common/utils/UrlUtils';
import { getRef, setRef } from 'app/common/utils/ReactUtils';
import 'app/common/components/Navbar.scss';

const bem = bemify('navbar');

const NavbarItem = createReactClass({
  displayName: 'NavbarItem',

  propTypes: {
    isActive: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool,
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    shouldScrollToTop: PropTypes.bool,
    onClick: PropTypes.func,
    renderAfterText: PropTypes.node,
  },

  getDefaultProps() {
    return {
      onClick: () => {},
      shouldScrollToTop: true,
    };
  },

  render() {
    const {
      isActive,
      isDisabled,
      text,
      url,
      onClick,
      renderAfterText,
      shouldScrollToTop,
    } = this.props;
    const className = bem('__link', {
      '--active': isActive,
      '--disabled': isDisabled,
    });
    return (
      <Link
        className={className}
        href={url}
        isDisabled={isDisabled}
        onClick={onClick}
        shouldScrollToTop={shouldScrollToTop}
      >
        <TruncatedText>{text}</TruncatedText>
        {renderAfterText}
      </Link>
    );
  },
});

const NavbarHighlight = ({ left, width }) => (
  <div
    className={bem('__highlight')}
    style={{
      transform: `translateX(${left}px) scaleX(${width})`,
      width: '1px', // ensure `scaleX` works as intended
    }}
  />
);

NavbarHighlight.propTypes = {
  left: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};

NavbarHighlight.defaultProps = {
  left: 0,
  width: 0,
};

const DefaultWrapper = ({ children, className }) => (
  <div className={className}>{children}</div>
);

export const NavbarShape = {
  isPadded: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape(
      _.omit(NavbarItem.propTypes, 'isActive') // eslint-disable-line react/forbid-foreign-prop-types
    )
  ).isRequired,
  currentUrl: PropTypes.string.isRequired,
  className: PropTypes.string,
  Wrapper: PropTypes.func.isRequired,
  kind: KindPropType,
  activeIndex: PropTypes.number,
};

const Navbar = createReactClass({
  displayName: 'Navbar',
  mixins: [PureRenderMixin],
  propTypes: NavbarShape,

  getDefaultProps() {
    return {
      isPadded: true,
      Wrapper: DefaultWrapper,
      activeIndex: null,
    };
  },

  getInitialState() {
    return { left: 0, width: 0 };
  },

  moveHighlight() {
    const activeItem = getRef(this, 'activeItem');
    if (!activeItem) return;

    // Use `offsetX` here instead of `getBoundingClientRect`
    // to ensure we're positioning relative to _container_
    // rather than _viewport_. This ensures that the hightight
    // is positioned correctly while resizing the page.
    this.setState({
      left: Math.floor(activeItem.offsetLeft),
      width: Math.ceil(activeItem.offsetWidth),
    });
  },

  componentDidMount() {
    this.moveHighlight();
  },

  componentDidUpdate(prevProps) {
    if (
      prevProps.currentUrl !== this.props.currentUrl ||
      prevProps.activeIndex !== this.props.activeIndex ||
      _.some(this.props.items, item => item.renderAfterText !== null)
    ) {
      this.moveHighlight();
    }
  },

  doesUrlMatchCurrent(url) {
    return isSubUrlOf(this.props.currentUrl, url);
  },

  doesActiveIndexMatchCurrent(index) {
    return this.props.activeIndex === index;
  },

  renderNavItem(item, index) {
    // Can manually pass in an activeIndex to force isActive to a specified item index.
    // Can use this with the item's onClick to pass in the relevant activeIndex.
    const { activeIndex } = this.props;
    const isActive =
      activeIndex !== null
        ? this.doesActiveIndexMatchCurrent(index)
        : this.doesUrlMatchCurrent(item.url);
    return (
      <NavbarItem
        {...item}
        isActive={isActive}
        key={index}
        ref={isActive && setRef(this, 'activeItem')}
      />
    );
  },

  render() {
    const { props } = this;
    const { items, Wrapper } = props;
    const hasMatchingUrl = items
      .map(({ url }) => url)
      .some(this.doesUrlMatchCurrent);
    const hasMatchingActiveIndex = items
      .map((item, index) => index)
      .some(this.doesActiveIndexMatchCurrent);
    const highlight =
      hasMatchingUrl || hasMatchingActiveIndex ? (
        <NavbarHighlight {...this.state} />
      ) : null;
    return (
      <nav className={bem(toModifiers(props.kind), props.className)}>
        <Wrapper className={bem('__nav-items')}>
          {items.map(this.renderNavItem)}
          {highlight}
        </Wrapper>
      </nav>
    );
  },
});

export default Navbar;
